export const TABLE_UPDATE_INTERVAL = 300000
